import React from 'react';
import './index.scss';

function Card(props) {
    return(
        <div class="col">
            <div class="card card-block shadow-sm border-0">
                <img src={props.data.card.imageurl} class="card-img-top" alt="foto juri"/>
                <div class="card-body">
                    <h5>{props.data.card.nama}</h5>
                    <p class="card-text">{props.data.card.deskripsi}</p>
                </div>
            </div>
        </div>
    )
}

export default Card;